import { useEffect, useRef } from 'react';
import useIntersectionObserver from '../useIntersectionObserver';
import { ObservableRef, UseEnteredViewOptions } from './types';

const useEnteredView = (observableRef: ObservableRef, { threshold, onEntered }: UseEnteredViewOptions): void => {
    const entry = useIntersectionObserver(observableRef, { threshold, once: true });
    const entered = Boolean(entry && entry.isIntersecting);

    // remember the latest reference of the callback in ref,
    // this way it doesn't need to be placed in useEffect's deps
    const onEnteredRef = useRef<() => void>(onEntered);
    if (onEnteredRef.current !== onEntered) {
        onEnteredRef.current = onEntered;
    }

    useEffect(() => {
        if (entered) {
            onEnteredRef.current();
        }
    }, [entered]);
};

export default useEnteredView;
